import {Directive, ElementRef, Renderer2, OnInit} from '@angular/core';

@Directive({selector: '[agent-type]'})
export class AgentTypeDirective implements OnInit {
  constructor(private renderer2: Renderer2, public element: ElementRef) {}

  ngOnInit() {
    console.log('on init');
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      this.renderer2.addClass(document.body, 'ios-mobile');
    } else if (navigator.userAgent.match(/Android/i)) {
      this.renderer2.addClass(document.body, 'android');
    } else if (navigator.userAgent.match(/Macintosh/i)) {
      this.renderer2.addClass(document.body, 'mac');
    } else if (navigator.userAgent.match(/Windows/i)) {
      this.renderer2.addClass(document.body, 'windows');
    }
  }
}
